export const container = {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    fontFamily: 'Arial, sans-serif'
};
    
export const imageContainer = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20
};
    
export const underContainer = {
    display: 'flex',
    flex: 1
};
    
export const side = {
    flex: 1,
    padding: 20,
    boxSizing: 'border-box'
};
    
export const dropzone = {
    width: 250,
    height: 200,
    border: '2px dashed #aaa',
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: '#666',
    overflow: 'hidden',
    position: 'relative',
    background: '#fafafa'
};
    
export const dropzoneImg = {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain'
};
    
export const row = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 12
};
    
export const label = {
    width: 140,
    textAlign: 'right',
    marginRight: 8,
    fontSize: 14
};

export const shortLabel = {
    textAlign: 'right',
    marginRight: 8,
    marginLeft: 12,
    fontSize: 14
};
    
export const textarea = {
    flex: 1,
    fontSize: 14,
    padding: '6px 8px',
    border: '1px solid #ccc',
    borderRadius: 4,
    resize: 'none',
    fontFamily: 'inherit'
};